"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyClassifier = void 0;
const DEFAULT_TEXT_LANG_ID = ["ja", "jp"];
class KeyClassifier {
    constructor(options) {
        this.options = options;
    }
    classify(key) {
        const lowerCaseKey = key.toLowerCase();
        const parsedLangId = this.parseLangIdFromKey(lowerCaseKey, this.options.langAliases);
        // detect if the keytype is text
        if (this.options.originalScriptField) {
            if (key === this.options.originalScriptField) {
                return { type: "text" };
            }
        }
        else {
            if (parsedLangId && DEFAULT_TEXT_LANG_ID.includes(parsedLangId)) {
                return { type: "text" };
            }
        }
        // detect if the keytype is translation
        if (this.options.translatedScriptFieldFormat) {
            // format SHOULD include {locale}
            const localePattern = this.options.translatedScriptFieldFormat.match(/\{locale\}/g);
            if ((localePattern === null || localePattern === void 0 ? void 0 : localePattern.length) === 1) {
                const split = this.options.translatedScriptFieldFormat.split("{locale}");
                if (split.length === 2) {
                    const [prefix, suffix] = split;
                    if (key.startsWith(prefix) &&
                        key.endsWith(suffix) &&
                        key.length > prefix.length + suffix.length) {
                        let langId = key;
                        if (prefix.length)
                            langId = langId.slice(prefix.length);
                        if (suffix.length)
                            langId = langId.slice(0, -suffix.length);
                        if (this.options.langAliases) {
                            for (const [langIdKey, aliases] of Object.entries(this.options.langAliases)) {
                                if (aliases.includes(langId)) {
                                    return { type: "translation", langId: langIdKey };
                                }
                            }
                        }
                        if (langId.length >= 2)
                            return { type: "translation", langId };
                    }
                }
            }
        }
        else {
            // use original logic
            if (parsedLangId !== null) {
                return {
                    type: "translation",
                    langId: parsedLangId,
                };
            }
        }
        return { type: "custom" };
    }
    parseLangIdFromKey(lowerCaseKey, langAliases, prefix = "text") {
        if (!lowerCaseKey.startsWith(prefix))
            return null;
        if (lowerCaseKey.length <= prefix.length)
            return null;
        const langId = lowerCaseKey.slice(prefix.length).replace(/^_/, "");
        if (langId.length < 2)
            return null;
        if (langAliases) {
            for (const [langIdKey, aliases] of Object.entries(langAliases)) {
                if (aliases.includes(langId)) {
                    return langIdKey;
                }
            }
        }
        return langId;
    }
}
exports.KeyClassifier = KeyClassifier;
